import React from "react";
import Button from "./Button";

const AlertBox = (props) => {
  const { handleAlert, alertFunc, alertType } = props;

  let alertTitle, alertMessage, alertSize, actionWord;

  if (alertType === "deleteProperty") {
    alertMessage = "Are you sure you want to delete this property?";
    alertSize = "h-48 w-60";
  }
  if (alertType === "deleteRoom") {
    alertMessage = "Are you sure you want to delete this room?";
    alertSize = "h-48 w-60";
  }
  if (alertType === "deleteLease") {
    alertMessage = "Are you sure you want to delete this lease?";
    alertSize = "h-48 w-60";
  }
  if (alertType === "removeFromPublished") {
    alertMessage = "Are you sure you want to remove this post?";
    alertSize = "h-48 w-60";
    actionWord = "Remove";
  }
  if (alertType === "archiveLease") {
    alertMessage = "Are you sure you want to archive this lease?";
    alertSize = "h-56 w-60";
    actionWord = "Archive";
  }
  if (alertType === "deleteBill") {
    alertMessage = "Are you sure you want to delete this bill?";
    alertSize = "h-48 w-60";
    actionWord = "Delete";
  }
  if (alertType === "deleteChore") {
    alertMessage = "Are you sure you want to delete this chore?";
    alertSize = "h-48 w-60";
    actionWord = "Delete";
  }
  if (alertType === "newProfile") {
    alertTitle = "Complete Your Profile";
    alertMessage = "Completed profiles receive 10x more responses.";
    alertSize = "h-60 w-72";
    actionWord = "Okay";
  }
  if (alertType === "exitStripe") {
    alertTitle = "Connect Bank Account";
    alertMessage = "Continue later by visiting Account Settings.";
    alertSize = "h-72 w-72";
    actionWord = "Okay";
  }
  if (alertType === "propertyUpgrade") {
    alertTitle = "Upgrade Your Plan";
    alertMessage = "You have exceed the number of properties for this plan.";
    alertSize = "h-72 w-72";
    actionWord = "Upgrade";
  }
  if (alertType === "tenantUpgrade") {
    alertTitle = "Upgrade Your Plan";
    alertMessage = "You have exceed the number of tenants for this plan.";
    alertSize = "h-72 w-72";
    actionWord = "Upgrade";
  }
  if (alertType === "manageChores") {
    alertTitle = "Add a Tenant First";
    alertMessage = "You can't manage chores without any tenants.";
    alertSize = "h-60 w-72";
    actionWord = "Okay";
  }
  if (alertType === "manageBills") {
    alertTitle = "Add a Tenant First";
    alertMessage = "You can't manage bills without any tenants.";
    alertSize = "h-60 w-72";
    actionWord = "Okay";
  }

  if (alertType === "changeSubscription") {
    alertTitle = "Warning!";
    alertMessage = "You will lose Founder status if you change subscriptions.";
    alertSize = "h-60 w-72";
    actionWord = "Change";
  }

  return (
    <>
      <div
        className="w-screen h-screen fixed top-0 left-0 right-0 bg-black bg-opacity-50 mt-20 z-10"
        onClick={() => handleAlert(alertType)}
      ></div>
      <div
        className={`grid justify-items-center fixed inset-x-0 inset-y-0 mt-40 m-auto text-black bg-white border-snappily-orange
        border-2 rounded-2xl p-5 z-10 ${alertSize}`}
      >
        <div className="text-center mt-5">
          {alertTitle !== undefined && (
            <div className="text-2xl mb-4">{alertTitle}</div>
          )}
          <div className="text-lg">{alertMessage}</div>
          {alertType === "archiveLease" && (
            <div className="text-red-500 mt-2">(This cannot be undone!)</div>
          )}
        </div>
        <div className="absolute bottom-5">
          {alertType !== "newProfile" &&
            alertType !== "manageChores" &&
            alertType !== "manageBills" && (
              <Button
                background="bg-gray-400"
                text="text-white"
                opacity="bg-opacity-100"
                title="Cancel"
                height="h-10"
                width="min-w-20 p-1"
                borderColor="bg-gray-300"
                borderHover="hover:bg-white"
                customFunc={() => handleAlert(alertType)}
              />
            )}
          <Button
            background="bg-snappily-orange"
            text="text-white"
            opacity="bg-opacity-100"
            title={actionWord ? actionWord : "Delete"}
            height="h-10"
            width="min-w-20 p-1"
            borderHover="hover:bg-white"
            customFunc={() => {
              if (alertType === "newProfile") {
                handleAlert(alertType);
              } else {
                alertFunc();
                handleAlert(alertType);
              }
            }}
          />
        </div>
      </div>
    </>
  );
};

export default AlertBox;
